export const sanJuanOnboardingCardsEs = [
  {
    title: "¡Bienvenido a San Juan! 🇵🇷",
    body: "Durante este tour autoguiado a pie descubrirás la historia de San Juan visitando 12 lugares a tu propio ritmo.",
    bullets: [
      "Tiempo: 2 horas de inicio a fin",
      "Distancia: 2.4 kilómetros",
      "Cómo jugar: Desliza a la siguiente página"
    ]
  },
  {
    title: "Cómo Jugar",
    body: "Estas instrucciones se pueden revisar en cualquier momento tocando \"Ayuda\".",
    steps: [
      "Comienza en el Puerto de Cruceros – Tu aventura comienza en el Puerto de Cruceros del Viejo San Juan, justo al lado del Hotel Rumbao.",
      "Sigue el Camino – Sigue las direcciones a través de las 12 ubicaciones.",
      "Resuelve el Acertijo – En cada parada, abre la Pista de Cofresí, lee el acertijo e ingresa tu respuesta.",
      "Desbloquea Historias y Tips – Expande \"Historia y Cerca\" para escuchar la historia del lugar y encontrar recomendaciones locales.",
      "Reclama Tu Premio – ¡Completa los 12 acertijos para ganar un premio!"
    ]
  },
  {
    title: "Descarga para uso sin conexión",
    body: "Si no tienes servicio celular, puedes descargar este tour mientras estés en Wi-Fi tocando el botón de abajo antes de salir (opcional).",
    offline: true
  }
];
